module.exports = __webpack_public_path__ + "img/bag.6b5b65a0.svg";